// extracted by mini-css-extract-plugin
export default {"information_section":"InformationSection_information_section__stwmc","title":"InformationSection_title__AV721","content":"InformationSection_content__vcEKY"};